var GroupPickerViewModel;

GroupPickerViewModel = (function() {
  function GroupPickerViewModel(options) {
    options = options || {};
    this.defaultShouldShow = function(group) {
      if (group.type != null) {
        return ko.unwrap(group.type) === 'default';
      } else {
        return true;
      }
    };
    this.controlName = 'group_picker_' + Math.random().toString(36).substr(2, 9);
    this.shouldShow = options.shouldShow != null ? options.shouldShow : this.defaultShouldShow;
    this.groups = ko.asObservableArray(options.groups != null ? options.groups : []);
    this.isLoading = ko.asObservable(options.isLoading != null ? options.isLoading : false);
    this.loadingHtmlMessage = ko.asObservable(options.loadingHtmlMessage != null ? options.loadingHtmlMessage : "Fetching Groups&hellip;");
    this.emptyHtmlMessage = ko.asObservable(options.emptyHtmlMessage != null ? options.emptyHtmlMessage : "No Groups");
    this.selected = ko.asObservable(options.selectedGroup);
  }

  return GroupPickerViewModel;

})();
